import React from 'react';
import { ProductResult } from '../types/product';

interface ProductCardProps {
  product: ProductResult;
  rank: number;
}

/** 개별 상품 카드 컴포넌트 */
export default function ProductCard({ product, rank }: ProductCardProps) {
  const {
    cleanTitle, image, basePrice,
    mallName, link, isNaverPlus, isSuspicious, suspiciousReason,
    brand, category,
  } = product;

  return (
    <article
      className={`product-card ${isSuspicious ? 'suspicious' : ''}`}
      aria-label={`${rank}위: ${cleanTitle}`}
    >
      {isSuspicious && (
        <div className="suspicious-badge" role="alert">
          ⚠️ 주의: {suspiciousReason}
        </div>
      )}

      <div className="product-rank">#{rank}</div>

      <div className="product-image">
        <img src={image} alt={cleanTitle} loading="lazy" />
      </div>

      <div className="product-info">
        <h3 className="product-title">{cleanTitle}</h3>

        {brand && <p className="product-brand">{brand}</p>}
        {category && <p className="product-category">{category}</p>}

        <div className="product-price-section">
          <div className="price-row total">
            <span className="label">상품가</span>
            <span className="value total-price">
              {basePrice.toLocaleString()}원
            </span>
          </div>
          <p className="price-note">배송비·쿠폰·카드할인은 판매처에서 확인하세요</p>
        </div>

        <div className="product-meta">
          <span className={`mall-name ${isNaverPlus ? 'naver-plus' : ''}`}>
            {isNaverPlus ? '🟢 ' : ''}{mallName}
          </span>
        </div>

        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="buy-button"
          aria-label={`${cleanTitle} 구매하러 가기`}
        >
          구매하러 가기
        </a>
      </div>
    </article>
  );
}
